import React from "react";
import "./paginationPanel.css";
import { Pagination } from "react-bootstrap";

const PaginationPanel: React.FC<{
  pageCount: number;
  pageIndex: number;
  onPageIndexChange: (page: number) => void;
  className?: string;
}> = (props) => {
  if (props.pageCount <= 1) {
    return null;
  }

  let items = [];

  if (props.pageCount <= 10) {
    for (let i = 1; i <= props.pageCount; i++) {
      items.push(
        <Pagination.Item
          key={i}
          active={i === props.pageIndex}
          onClick={() => props.onPageIndexChange(i)}
        >
          {i}
        </Pagination.Item>
      );
    }
  } else {
    items.push(
      <Pagination.Prev
        disabled={props.pageIndex === 1}
        key="prev"
        onClick={() => props.onPageIndexChange(props.pageIndex - 1)}
      />
    );

    if (props.pageIndex > 1) {
      items.push(
        <Pagination.Item
          disabled={props.pageIndex === 1}
          key="first"
          onClick={() => props.onPageIndexChange(1)}
        >
          {1}
        </Pagination.Item>
      );
    }
    if (props.pageIndex > 2) {
      items.push(<Pagination.Ellipsis key="more" />);
    }

    items.push(
      <Pagination.Item key={props.pageIndex} active={true}>
        {props.pageIndex}
      </Pagination.Item>
    );

    if (props.pageIndex <= props.pageCount - 2) {
      items.push(<Pagination.Ellipsis key="others" />);
    }

    if (props.pageIndex < props.pageCount) {
      items.push(
        <Pagination.Item
          key={props.pageCount + 1}
          onClick={() => props.onPageIndexChange(props.pageCount)}
        >
          {props.pageCount}
        </Pagination.Item>
      );
    }

    items.push(
      <Pagination.Next
        disabled={props.pageIndex === props.pageCount}
        key="next"
        onClick={() => props.onPageIndexChange(props.pageIndex + 1)}
      />
    );
  }

  return <Pagination className={props.className}>{items}</Pagination>;
};

export default PaginationPanel;
